var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('p',{staticClass:"chinese-name"},[_vm._v("机构概况")]),_vm._v(" "),_c('p',{staticClass:"english-name"},[_vm._v("ABOUT US")]),_vm._v(" "),_c('div',{staticClass:"desc-content",domProps:{"innerHTML":_vm._s(_vm.orgDesc)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d784f772","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/institutionalOverview/siderContent01.vue
// module id = null
// module chunks = 